import { render, staticRenderFns } from "./ApplictionPromiseGoods.vue?vue&type=template&id=573447af"
import script from "./ApplictionPromiseGoods.vue?vue&type=script&lang=js"
export * from "./ApplictionPromiseGoods.vue?vue&type=script&lang=js"
import style0 from "./ApplictionPromiseGoods.vue?vue&type=style&index=0&id=573447af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports